export default "__VITE_ASSET__31702f21__"